import { Timestamp } from 'firebase/firestore';

export enum InvitationStatus {
  PENDING = 'pending',
  ACCEPTED = 'accepted',
  EXPIRED = 'expired',
}

export enum InvitationType {
  ORGANIZATION = 'organization',
  ADMIN = 'admin',
}

/** Whether GCCA has cleared a member invitation to be sent. */
export enum InvitationApprovalStatus {
  PENDING = 'pending',
  APPROVED = 'approved',
  REJECTED = 'rejected',
}

export interface Invitation {
  id: string;
  organizationId?: string;
  organizationName?: string;
  email: string;
  invitedBy: string;
  userId?: string;
  status: InvitationStatus;
  type: InvitationType;
  expiresAt: Timestamp;
  acceptedAt?: Timestamp;
  role?: string;
  createdAt: Timestamp;
  updatedAt: Timestamp;
  approvalStatus: InvitationApprovalStatus;
  reviewedBy?: string;
  reviewedAt?: Timestamp;
  reviewComment?: string;
  sentAt?: Timestamp;
}

/** A member invitation as shown on the GCCA review screen. */
export interface InvitationForReview extends Invitation {
  organizationName: string;
  invitedByName: string;
  invitedByEmail: string;
  reviewedByName?: string;
}

export interface ReviewInvitationRequest {
  status: InvitationApprovalStatus.APPROVED | InvitationApprovalStatus.REJECTED;
  comment?: string;
}

export interface InvitationsForReviewResponse {
  data: {
    invitations: InvitationForReview[];
    total: number;
    currentPage: number;
    hasNextPage: boolean;
  };
}

export interface AdminInvitationsPage {
  invitations: Invitation[];
  total: number;
  currentPage: number;
  pageCount: number;
  hasNextPage: boolean;
  countsByStatus: Record<string, number>;
}

export interface AdminInvitationsPageResponse {
  data: AdminInvitationsPage;
}

export interface DeleteInvitationResult {
  message: string;
  purgedUser: boolean;
}

export interface CreateInvitationRequest {
  email: string;
  role?: string;
  type?: InvitationType;
}

export interface InvitationResponse {
  data: Invitation;
}

export interface InvitationsResponse {
  data: Invitation[];
}

/**
 * Interface for user options in the dropdown for content transfer
 */
export interface UserOption {
  id: string;
  displayName: string;
  invitationId: string;
}
